import { useAtom } from 'jotai';
import { appAtom } from '@/store/appAtom';

export const useApp = () => {
  return useAtom(appAtom);
};
